import { faArrowUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";

const BackToTop = () => {
    const [visible, setVisible] = useState(false);

    // Show button after scrolling down 300px
    useEffect(() => {
        const toggleVisibility = () => {
            setVisible(window.scrollY > 300);
        };

        window.addEventListener("scroll", toggleVisibility);
        return () => window.removeEventListener("scroll", toggleVisibility);
    }, []);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };

    return (
        visible && (
            <button
            className="btn-top"
                onClick={scrollToTop}
                style={{
                    position: "fixed",
                    bottom: "30px",
                    right: "30px",
                    zIndex: 999,
                    padding: "10px 14px",
                    borderRadius: "50%",
                    border: "none",
                    backgroundColor: "#004d40",
                    color: "#fff",
                    fontSize: "20px",
                    cursor: "pointer",
                    boxShadow: "0 4px 8px rgba(0,0,0,0.3)",
                }}
                title="Back to top"
            >
                <FontAwesomeIcon
                    icon={faArrowUp}
                    color="#ffffff"
                    size="xl"
                />
            </button>
        )
    );
};

export default BackToTop;
